import React from 'react';
import Text from '../containers/Text';
import { formatDate, showHolidays } from '../utilities/showHolidays';

const HolidayAlert = ({shop}) => {
  if (!shop.holidays || shop.holidays.length === 0) {
    return null;
  } else {
    if (shop.onHoliday || showHolidays(shop.holidays[0])) {
      return (
        <p className="holiday-alert alert alert-danger">
          <i className="halflings halflings-warning-sign x2"></i>

          <strong><Text id="details.on-holiday.note" /></strong>
          <br />
          <Text id="details.on-holiday" placeholders={{
            from: formatDate(shop.holidays[0].from),
            to: formatDate(shop.holidays[0].till)
          }}/>
        </p>
      );
    } else {
      return null;
    }
  }
}

export default HolidayAlert;
